import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
    providedIn: 'root'
})
export class SynapseAutocompleteService {

    private httpOptions = {
        headers: new HttpHeaders({
            Authorization: ""
        })
    };
    private uri = "https://api.synapse-medicine.com/prescription-autocomplete/v1/autocomplete";

    constructor(
        private http: HttpClient,
        private _log: LoginService,
        private _snack: SnackbarService
    ) { }

    async autocomplete(reqObject: SynapseAutocompleteReq): Promise<SynapseAutocompleteResp[]> {
        const synapseLicence = this._log.getCurrentProfil().licenceBdd;
        if (synapseLicence) {
            this.httpOptions.headers = this.httpOptions.headers.set("Authorization", "Bearer " + synapseLicence);
            const res = (await this.http.post(this.uri, reqObject, this.httpOptions).toPromise()) as SynapseAutocompleteResp[];
            return res;
        } else {
            this._snack.openSnackBar("Veuillez rensseigner votre licence BCB dans vos paramètres utilisateur");
        }
    }

    async getByCis(cis: string): Promise<SynapseEntiteTherapeutique> {
        const synapseLicence = this._log.getCurrentProfil().licenceBdd;
        if (synapseLicence) {
            this.httpOptions.headers = this.httpOptions.headers.set("Authorization", "Bearer " + synapseLicence);
            const res = (await this.http.get(`https://api.synapse-medicine.com/drug-information/v1/branded-drug/fr/${cis}`, this.httpOptions).toPromise()) as SynapseEntiteTherapeutique;
            return res;
        } else {
            this._snack.openSnackBar("Veuillez rensseigner votre licence BCB dans vos paramètres utilisateur");
        }
    }
}

export interface SynapseAutocompleteReq {
    text: string,
    type: SynapseTypeEntiteTherapeutiqueEnum,
    size: number,
    lang?: SynapseLangEnum,
    field?: SynapseFieldEnum
}

export interface SynapseAutocompleteResp {
    entity: SynapseEntiteTherapeutique,
    score: number
}

export interface SynapseEntiteTherapeutique {
    label?: string,
    uri?: string,
    type: SynapseTypeEntiteTherapeutiqueEnum,
    cis: string,
    shortname?: string,
    brandname?: string,
    ingredients?: any,
    moieties?: any[],
    posologies?: SynapsePosologie[],
    motif?: string
}

export interface SynapsePosologie {
    id?: string,
    frequencyUnit?: string,
    durationUnit?: string,
    duration?: number,
    dosageType?: SynapseTypeDosagePosologieEnum,
    dosage?: SynapseDefaultDosage | SynapseDailyDosage | SynapseWeeklyDosage
}

export interface SynapseDefaultDosage {
    doseUnit?: string,
    quantity?: number,
    frequency?: number
}

export interface SynapseDailyDosage {
    doseUnit?: string,
    quantities?: SynapseDailyQuantities,
    uponRequest?: boolean
}

export interface SynapseDailyQuantities {
    morning?: number,
    noon?: number,
    evening?: number,
    night?: number
}

export interface SynapseWeeklyDosage {
    doseUnit?: string,
    quantities?: SynapseWeeklyQuantities
}

export interface SynapseWeeklyQuantities {
    monday?: number,
    tuesday?: number,
    wednesday?: number,
    thursday?: number,
    friday?: number,
    saturday?: number,
    sunday?: number
}

export interface SynapsePatientProfile {
    grounds?: SynapseGroundsPatient,
    age?: number,
    height?: number,
    weight?: number,
    creatinine?: SynapaseCreatininePatient,
    medicalHistory?: string[],
    sex?: SynapseSexPatientEnum,
    pregnant?: boolean,
    lmp?: string,
    nursing?: boolean
}

export interface SynapseGroundsPatient {
    kidneyFailure?: SynapseKidneyFailureEnum,
    hepaticFailure?: SynapseHepaticFailureEnum | string,
    cardiacFailure?: SynapseCardiacFailureEnum | string,
    allergies?: any[],
    comorbidities?: string[]

}

export interface SynapaseCreatininePatient {
    value: number,
    unit: SynapseCreatinineUnitEnum
}

export enum SynapseSexPatientEnum {
    FEMALE = "F",
    MALE = "M"
}

export enum SynapseCreatinineUnitEnum {
    UMOL_L = "umol/L",
    MG_L = "mg/L",
    MG_DL = "mg/dL"
}

export enum SynapseKidneyFailureEnum {
    NONE = "none",
    LIGHT = "light",
    MODERATE = "moderate",
    HEAVY = "heavy",
    TERMINAL = "terminal"
}

export enum SynapseHepaticFailureEnum {
    NONE = "none",
    LIGHT = "light",
    MODERATE = "moderate",
    HEAVY = "heavy"
}

export enum SynapseCardiacFailureEnum {
    NONE = "none",
    LIGHT = "light",
    MODERATE = "moderate",
    HEAVY = "heavy"
}

export enum SynapseTypeEntiteTherapeutiqueEnum {
    MARQUE_MEDICAMENT = "branded-drug",
    MOLECULE_ACTIVE = "pharmaceutical-ingredient",
    CLASSE_THERAPEUTIQUE = "therapeutic-class"
}

export enum SynapseTypeDosagePosologieEnum {
    DEFAULT = "default",
    DAILY = "daily",
    WEEKLY = "weekly"
}

export enum SynapseLangEnum {
    ALLEMAND = "de-DE",
    ANGLAIS_GB = "en-GB",
    ANGLAIS_USA = "en-US",
    ESPAGNOL = "es-ES",
    FRANCAIS = "fr-FR",
    Italien = "it-IT"
}

export enum SynapseFieldEnum {
    LABEL = "label",
    MOIETIES = "moieties"
}
